// extracted by mini-css-extract-plugin
export default {"layout":"PageLayout_layout__hSbdI"};